import React from "react";

//from shared components
import Pagination from "SharedComponents/Pagination/Pagination";
import Table from "../../Table";
import { riskLevels, colors, botClassificationName } from "components/AFP/Constants";
import { utcTimeStringToLocalTimeString } from "SharedComponents/DateManager";
import BotDetailsData from "../../Today/TodayPanels/BotDetails/BotDetailsData";
import { useDispatch, useSelector } from "react-redux";
import { getReportingResultsTableData } from "../ReportingDataController/ReportingDataController";

const ReportingLargeDataTable = (props) => {
    const { page, setPage } = props;
    const botDetails = useSelector(state => state?.botDetails.data);
    const data = props.data;
    const itemsPerPage = 5;
    const regionNamesInEnglish = new Intl.DisplayNames(['en'], { type: 'region' });
    const dispatch = useDispatch();


    // React.useEffect(() => {
    //         BotDetailsData({ timeRange: botDetails.timeRange }, dispatch, page);
    //     }, [page]);

    const regexForReferrer = (val) => {
        const result = val.replace(/https?:\/\/(www\.)?|www\./, '');
        return result;
    };

    const botRisk = (val) => {
        return (
            <div className="bot_risk_cell" style={{ backgroundColor: colors[val] }} >
                {riskLevels[val]}
            </div>
        )
    };

    const headers = [
        { headerName: "Last Seen", field: "last_seen", valueFormatter: (val) => utcTimeStringToLocalTimeString(val, "", "HH:mm:ss"), title: (val) => utcTimeStringToLocalTimeString(val, "", "HH:mm:ss") },
        { headerName: "IP Address", field: "ip" },
        { headerName: "Country", field: "country", title: (val) => (val !== 'unknown' && val !== "null") ? regionNamesInEnglish.of(val) : val },
        { headerName: "Referrer", field: "referrer", valueFormatter: (val) => regexForReferrer(val) },
        { headerName: "OS", field: "os" },
        { headerName: "Landing Page", field: "landing_page", valueFormatter: (val) => decodeURI(val) },
        { headerName: "Page Loads", field: "page_loads" },
        { headerName: "Bot Type", field: "bot_classification_id", valueFormatter: (val) => botClassificationName[val], title: (val) => botClassificationName[val] },
        { headerName: "Bot Risk", field: "bot_risk_type_id", valueFormatter: (val) => botRisk(val), title: (val) => riskLevels[val] },
    ];

const downloadBotDetailsAsCSV = async () => {
    // Use props.queryDetails for filtering
    let allBotDetails = await getReportingResultsTableData({ ...props.queryDetails, page: 1, limit: 3000 }, dispatch);
    if (!allBotDetails?.items || allBotDetails.items.length === 0) {
        console.warn("No bot details available to download.");
        return;
    }

    // Extract headers
    const CSVheaders = ["Last Seen", "IP Address", "Country", "Referrer", "OS", "Landing Page", "Page Loads", "Bot Type", "Bot Risk"];
    
    // Map data rows
    const rows = allBotDetails.items.map(item => [
        item.last_seen,
        item.ip,
        item.country,
        item.referrer,
        item.os,
        decodeURIComponent(item.landing_page),
        item.page_loads,
        botClassificationName[item.bot_classification_id],
        riskLevels[item.bot_risk_type_id]
    ]);

    // Combine headers and rows into CSV format
    const csvContent = [CSVheaders, ...rows]
        .map(row => row.map(value => `"${value || ""}"`).join(",")) // Escape values with quotes
        .join("\n");

    // Create a Blob and trigger download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "bot_details.csv";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

    /*
/* Function to copy text to clipboard currently not in use
/* Use `<button className="reporting-btn" onClick={handleCopy}>Copy to Clipboard</button>` to trigger the copy action

const copyToClipboard = (text) => {
    if (navigator.clipboard && window.isSecureContext) {
        // Use the modern clipboard API
        navigator.clipboard.writeText(text).then(() => {         
        }).catch(err => {
            console.error("Failed to copy text: ", err);
        });
    } else {
        // Fallback for environments without clipboard API
        console.warn("Clipboard API not supported or insecure context.");
    }
};

const handleCopy = () => {
    const ipAddresses = botDetails?.items?.map(item => item.ip) || [];
    copyToClipboard("[" +ipAddresses+ "]");
};
*/

    if (props.data === false) {
        return (
            <div>
                <h3>Reporting big table</h3>
                <div className="bot-details-section">
                    <p>No data available</p>
                </div>
            </div>
        )
    } else {

        console.log("Bot Details Data:", data);

        return (
            <div>
                <h3>Reporting big table</h3>
                <div className="bot-details-section">
                    <Table
                        headers={headers}
                        data={data.items}
                    />
                    {(data.paging?.total ?? 0) > 10 &&
                        <Pagination
                            paging={data.paging}
                            currentPage={page}
                            setCurrentPage={setPage}
                            pageLimit={itemsPerPage}
                        />
                    }
                </div>
                <button className="reporting-btn" onClick={downloadBotDetailsAsCSV}>Download Bot Details as CSV</button>
            </div>
        )
    }
};

export default ReportingLargeDataTable;